import React from "react";
import styles from "../investor-listing/index.module.scss";
import InvestorListingSkeleton from "../../../skeleton/inv-acc-skeleton";
import InvCard from "../inv-card";
import { useInvMyAccounts } from "../../../hooks/react-query/inv-exchange/useInvMyAccounts";
import InvWebCard from "../inv-web-card";

export default function InvestorMyAccounts() {
  const { data, isLoading } = useInvMyAccounts();

  return (
    <div className={styles.investorListing}>
      {isLoading && <InvestorListingSkeleton />}
      {!isLoading && data?.length > 0
        ? data?.map((item: any, index: number) => (
            <div
              key={`inv-account-${index}-${item.accountName}`}
              className={styles.invListItemWrapper}
            >
              <InvCard
                userName={item?.userName}
                myAccounts={true}
                address={item.address}
                checkoutId={item.checkoutId}
                createdAt={item.createdAt}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                portalStatus={item?.portalStatus}
              />
              <InvWebCard
                portalStatus={item?.portalStatus}
                userName={item?.userName}
                myAccounts={true}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
              />
            </div>
          ))
        : !isLoading && (
            <div className={styles.noDataFound}>
              <img src="/images/no-data-found.svg" alt="No Data" />
              <p>No investors found</p>
            </div>
          )}
    </div>
  );
}
